import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getLookupList(entities: string[] = []):Observable<any> {
    return this.httpClient.get(this._endpoint + 'lookup/lookupList?entities=' + entities.join(','));
  }
}